"use client";

import { pathToSlugs } from "@utils/slugHelper";
import { usePathname } from "next/navigation";
import { ReactNode, useEffect, useState } from "react";

import navigationStyles from "./navigation.module.css";
import { shouldHideDesktopNavigation } from "./navigationVisibility";

export default function NavigationSlot({
  initialPath,
  is404,
  children,
}: {
  initialPath: string;
  is404: boolean;
  children: ReactNode;
}) {
  const pathname = usePathname();
  const [hasHydrated, setHasHydrated] = useState(false);

  useEffect(() => {
    setHasHydrated(true);
  }, []);

  const path = hasHydrated ? (pathname ?? initialPath) : initialPath;
  const hideDesktopNavigation = shouldHideDesktopNavigation(pathToSlugs(path)[0], is404, path);

  return (
    <div className={hideDesktopNavigation ? undefined : navigationStyles.navigationSlot}>
      {children}
    </div>
  );
}
